export default __webpack_public_path__ + "locales/hy-AM/DeleteSelfProfileDialog.json?hash=eee7914e8e4625bd064597eb479798e5";